/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */
export default {
  setUser: (state, value) => (state.user = value)
}
